import { investmentsRoutes, InvestmentsRoutes } from './investments';
import { BaseQuestionnaireRoute } from '../slice';
import { WagesRoutes, wagesRoutes } from './wages';
import { HomeSaleRoutes, homeSaleRoutes } from './homeSale';
import {
  CorporationTrustRoutes,
  corporationTrustRoutes,
} from './corporationTrust';
import { otherIncomeRoutes, OtherIncomeRoutes } from './otherIncome';
import { passiveIncomeRoutes, PassiveIncomeRoutes } from './passiveIncome';
import { selfEmploymentRoutes, SelfEmploymentRoutes } from './selfEmployment';

export type IncomeRoutes = BaseQuestionnaireRoute & {
  wages: WagesRoutes;
  corporationTrust: CorporationTrustRoutes;
  homeSale: HomeSaleRoutes;
  investments: InvestmentsRoutes;
  otherIncome: OtherIncomeRoutes;
  passiveIncome: PassiveIncomeRoutes;
  selfEmployment: SelfEmploymentRoutes;
};

export const incomeRoutes: { income: IncomeRoutes } = {
  income: {
    title: 'Income',
    path: 'income',
    isValid: undefined,
    ...wagesRoutes,
    ...passiveIncomeRoutes,
    ...selfEmploymentRoutes,
    ...corporationTrustRoutes,
    ...otherIncomeRoutes,
    ...investmentsRoutes,
    ...homeSaleRoutes,
  },
};
